// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"121":"672c28eb3e16c3d3","539":"6daddd03263a483e"}[chunkId] + ".js";
};